import clsx from 'clsx';

type IconProps = {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  size?: number;
  color?: string;
};

const Icon: React.FC<IconProps> = ({
  name, className, style, size = 16, color,
}) => (
  <span
    className={clsx('material-symbols-rounded', className)}
    style={{
      fontSize: size,
      color,
      ...style,
    }}
  >
    {name}
  </span>
);

export default Icon;
